import { render, staticRenderFns } from "./funded-promotions-list.vue?vue&type=template&id=89434736&scoped=true"
import script from "./funded-promotions-list.vue?vue&type=script&lang=js"
export * from "./funded-promotions-list.vue?vue&type=script&lang=js"
import style0 from "./funded-promotions-list.vue?vue&type=style&index=0&id=89434736&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89434736",
  null
  
)

export default component.exports